// Studyo Today Backend
// Package studyo.today.planners.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/planners/v1/resources/participation_request_state.proto (package studyo.today.planners.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/planners/v1/resources/participation_request_state.proto.
 */
export const file_studyo_today_planners_v1_resources_participation_request_state = /*@__PURE__*/
  fileDesc("CkRzdHVkeW8vdG9kYXkvcGxhbm5lcnMvdjEvcmVzb3VyY2VzL3BhcnRpY2lwYXRpb25fcmVxdWVzdF9zdGF0ZS5wcm90bxIic3R1ZHlvLnRvZGF5LnBsYW5uZXJzLnYxLnJlc291cmNlcyreAQoZUGFydGljaXBhdGlvblJlcXVlc3RTdGF0ZRIyCi5SRVFVRVNURURfUEFSVElDSVBBVElPTl9DT0RFX1NUQVRFX1VOU1BFQ0lGSUVEEAASLQopUkVRVUVTVEVEX1BBUlRJQ0lQQVRJT05fQ09ERV9TVEFURV9VTlJFQUQQARIuCipSRVFVRVNURURfUEFSVElDSVBBVElPTl9DT0RFX1NUQVRFX0dSQU5URUQQAhIuCipSRVFVRVNURURfUEFSVElDSVBBVElPTl9DT0RFX1NUQVRFX1JFRlVTRUQQA0IqqgInU3R1ZHlvLlRvZGF5LlBsYW5uZXJzLkdycGMuVjEuUmVzb3VyY2VzYgZwcm90bzM");

/**
 * Describes the enum studyo.today.planners.v1.resources.ParticipationRequestState.
 */
export const ParticipationRequestStateSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_planners_v1_resources_participation_request_state, 0);

/**
 * Possible states of a participation request
 *
 * @generated from enum studyo.today.planners.v1.resources.ParticipationRequestState
 */
export const ParticipationRequestState = /*@__PURE__*/
  tsEnum(ParticipationRequestStateSchema);

